import { Store } from 'src/store/index';

const isPopupActive = (store: Store, popupId: string) => store.app.activePopup === popupId;

export default isPopupActive;
